(() => {
	angular
		.module('main')
		.controller('ThankYouSignupController', ThankYouSignupController);

	ThankYouSignupController.$inject = ['$scope', '$rootScope'];

	function ThankYouSignupController($scope, $rootScope) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.firstName = $rootScope.firstName;
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/thankYouSignupController.js